module.exports = "/_next/static/images/teamStuffingExpansion-85ad1a246ae107691db6c9e1402a6e2c.webp";